import { render, staticRenderFns } from "./edit-grade-dialog.vue?vue&type=template&id=bcfe81fc&scoped=true&"
import script from "./edit-grade-dialog.vue?vue&type=script&lang=js&"
export * from "./edit-grade-dialog.vue?vue&type=script&lang=js&"
import style0 from "./edit-grade-dialog.vue?vue&type=style&index=0&id=bcfe81fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcfe81fc",
  null
  
)

export default component.exports